<template>
    <div class="animated fadeIn"> 
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Audit Scan Details</strong>       
                    </div> 
                    <b-row>
                        <b-col md="12">
                            <b-button v-if="totalRows>0"  style="float: right;" @click="downloadCSV()"
                            size="md" variant="primary">Download</b-button>
                        </b-col>
                        <br><br>
                       <b-col md="12">
                            <b style="float: right;"
                              >Total Records :<span style="color:red;"
                                >&nbsp;{{totalRows}}&nbsp;&nbsp;</span
                              ></b
                            >
                       </b-col>
                    </b-row>
                   <br>

                    <b-table   id="DailyAuditDetails"
                        responsive
                        show-empty
                        :busy="isBusy"
                        :items="items"
                        :fields="fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :filter="filter"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :sort-direction="sortDirection"
                        @filtered="onFiltered"
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                      <template slot="show_details" slot-scope="row">
                        <b-button size="sm"
                        @click="openmodalShow(row.item)">Show Details</b-button>
                      </template>
                      <!-- <template slot="hub_id" slot-scope="row">
                            <span>{{ row.item.hub_id=='398'?'365':row.item.hub_id }}</span>
                      </template> -->
                    </b-table>

                    <b-col md="12" class="my-1" >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="DailyAuditDetails"
                            >
                        </b-pagination>
                    </b-col>  

                    <!-- //open model -->
                    <b-modal v-model="modalShow" title="Audit Details" size="xl" hide-footer>
                        <b-col md="12">
                            <b-button v-if="totalRowsmodel>0" @click="logdownloadCSV()" style="float: right;" 
                            size="md" variant="primary">Download</b-button>
                        </b-col>
                        <br><br>
                        <b-row>
                           <b-col md="12">
                                <b style="float: right;"
                                  >Total Records :
                                  <span style="color:red;"
                                    >&nbsp;{{totalRowsmodel}}&nbsp;&nbsp;</span
                                  ></b
                                >
                           </b-col>
                        </b-row>
                        
                        <b-table id="AuditDetails"
                            responsive
                            show-empty
                            :busy="isBusymodel"
                            :items="itemsmodel"
                            :fields="fieldsmodel"
                            :per-page="perPagemodel"
                            :current-page="currentPagemodel"
                            :bordered="bordered"
                            :filter="filtermodel"
                            :sort-by.sync="sortBymodel"
                            :sort-desc.sync="sortDescmodel"
                            :sort-direction="sortDirectionmodel"
                            @filtered="onFiltered"
                        >
                        <div
                            slot="table-busy"
                            class="text-center text-danger my-2"
                        >
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                       
                        </b-table>

                        <b-col md="12" class="my-1" >
                            <b-pagination
                                v-model="currentPagemodel"
                                :total-rows="rowsmodel"
                                :per-page="perPagemodel"
                                aria-controls="AuditDetails"
                                >
                            </b-pagination>
                        </b-col>  
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
    data() {
        return {
            modalShow: false,
            totalRows : 0,
            items: [],
            fields: [
            { key: "audit_id", label: "Sr No.", sortable: true },
            // { key: "hub_id", label: "Hub ID", sortable: true },
            { key: "start_action", label: "Start Action", sortable: true },
            { key: "startdate", label: "Start Date", sortable: true },
            { key: "close_action", label: "Close Action", sortable: true },
            { key: "closedate", label: "Close Date", sortable: true },
            // { key: "createddate", label: "Created Date", sortable: true },
            { key: "createdby", label: "Created By", sortable: true },
            // { key: "lastmodifieddate", label: "Last Modified Date", sortable: true },
            { key: "lastmodifiedby", label: "Close By", sortable: true },
            { key: "show_details", label: "Actions"},
            ],
            perPage: 20,
            currentPage: 1,
            sortBy: null,
            sortDesc: true,
            sortDirection: "desc",
            filter: null,
            isBusy: false,
            //model 
            isBusymodel : false,
            itemsmodel : [],
            totalRowsmodel : 0,
            fieldsmodel: [
            // { key: "audit_id", label: "Audit ID", sortable: true },
            // { key: "hub_id", label: "Hub ID", sortable: true },
            { key: "shippingid", label: "Shipping Id", sortable: true },
            { key: "createddate", label: "Created Date", sortable: true },
            // { key: "createdby", label: "Created By", sortable: true },
            { key: "lastmodifieddate", label: "Last Modified Date", sortable: true },
            // { key: "lastmodifiedby", label: "Last Modified By", sortable: true },
            { key: "shipment_suggestion", label: "comment", sortable: true },
            ],
            perPagemodel : 20,
            currentPagemodel :1,
            sortBymodel: null,
            sortDescmodel: true,
            sortDirectionmodel: "desc",
            filtermodel: null,
            audit_detail : ''
        }
    },

    created() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        // this.hubid=userInfo.pickuplocationmasterid.toString();
        this.DailyAuditDetails();
        // this.AuditDetails();
    },

    computed: {
      rows() {
        return this.items.length
      },

      rowsmodel(){
        return this.itemsmodel.length
      }
    },

    methods: {

        DailyAuditDetails : function () {
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            this.isBusy = true;
            const obj = {}

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDailyAuditDetails`,obj)
            .then(result => {
                console.log("result",result)
                this.isBusy = false;
                if(result.body.returnmsg=='Successful'){
                    this.items = result.body.returnvalue;
                    
                    this.totalRows = result.body.returnvalue.length;
                }
                else{
                    this.items  = [];
                    this.totalRows = 0;
                }
            
            })
            .catch(ex => {
                console.log('error-----',ex);
            });
        },

        openmodalShow(value){
            this.modalShow= true;
            this.audit_detail = value;
            console.log("value",value)
            this.AuditDetails(value)
        },

        AuditDetails : function (dataval) {
            console.log(dataval)
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            this.isBusymodel = true;
            const obj = {
                audit_id : dataval.audit_id,
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/auditLogListing`,obj)
            .then(result => {
                console.log("result",result)
                this.isBusymodel = false;
                if(result.body.returnmsg=='Successful'){
                    this.itemsmodel = result.body.returnvalue;
                    
                    this.totalRowsmodel = result.body.returnvalue.length;
                }
                else{
                    this.itemsmodel  = [];
                    this.totalRowsmodel = 0;
                }
            
            })
            .catch(ex => {
                console.log('error-----',ex);
            });
        },

        downloadCSV: function() {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var csvObj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAuditDetailsCSV`,csvObj)
                .then((result) => {
                console.log(result.url);
                document.getElementById("overlay").style.display = "none";
                if (result.body == "success") {
                    this.$fire({
						text:"Please Check Your Mail For Downlod Link",
						type: "success",
						timer: 30000
					});
                } else {
                    this.$fire({
						text:"Can not Download",
						type: "error",
						timer: 30000
					});
                }
            });
        },

        logdownloadCSV: function() {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var csvObj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                audit_id : this.audit_detail.audit_id,
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAuditlogReport`,csvObj)
                .then((result) => {
                console.log(result.url);
                document.getElementById("overlay").style.display = "none";
                if (result.body == "success") {
                    this.$fire({
						text:"Please Check Your Mail For Downlod Link",
						type: "success",
						timer: 30000
					});
                } else {
                    this.$fire({
						text:"Can not Download",
						type: "error",
						timer: 30000
					});
                }
            });
        },
    },
}
</script>

<style>
table, th, td {
    border: 1px solid #dbcdcd;
}
</style>